import React from 'react';
import { selectedWork } from '../../data/portfolio';
import './SelectedWork.css';

function SelectedWork() {
  return (
    <section id="work" className="work-section" aria-labelledby="work-title">
      <div className="section-heading work-heading">
        <p>Selected work</p>
        <h2 id="work-title">주요 업무</h2>
      </div>

      <div className="work-list">
        {selectedWork.map((item) => (
          <article className="work-entry" key={item.id}>
            <div className="work-index" aria-hidden="true">{item.number}</div>
            <div className="work-body">
              <p className="work-context">{item.context}</p>
              <h3>{item.title}</h3>
              <p className="work-description">{item.description}</p>
              <ul>
                {item.details.map((detail) => <li key={detail}>{detail}</li>)}
              </ul>
              <p className="work-technologies" aria-label="사용 기술">
                {item.technologies.join(' · ')}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default SelectedWork;
